import { LayoutType } from 'signup-components/types';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import { BaseView } from './BaseView';
import { getStepConfig } from './getStepConfig';
import { useView } from './useView';
import { Step } from 'signup-constants/Step';
import { Data } from 'signup-constants/signupData/Data';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompanyNameView = () => {
  const stepKey = Step.CompanyName;
  const dataKey = Data.CompanyName;
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    layoutType
  } = useLayoutTemplate();
  const isSidePanel = layoutType === LayoutType.SidePanel;
  const stepConfig = getStepConfig(stepKey);
  if (!stepConfig) {
    return null;
  }
  const submitQuestion = () => {
    submit();
  };
  return /*#__PURE__*/_jsx(BaseView, {
    helperText: isSidePanel ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `views.${stepKey}.sidePanelHelperText`
    }) : null,
    children: /*#__PURE__*/_jsx(SignupDataInputForm, {
      dataKey: dataKey,
      inputMode: 'text',
      submit: submitQuestion
    }, dataKey)
  });
};